import cardNetworkType_PinTrialLimitFormMeta, { ICardNetTyp_PinTrialLimFormMeta } from "./cardNetTyp_PinTrialLimFormMeta";
import embossedDataFormMeta, { IEmbossedDataFormMeta } from "./embossedDataFormMeta";
import encodedTrackFormMeta, { IEncodedTrackFormMeta } from "./encodedTrackFormMeta";
import internetMailOrderFormMeta, { I_InternetMailOrderFormMeta } from "./internetMailOrderFormMeta";
import serviceCodeFormMeta, { IServiceCodeFormMeta } from "./serviceCodeFormMeta";

export interface IMagneticTapeApplicationFormMeta extends ICardNetTyp_PinTrialLimFormMeta, I_InternetMailOrderFormMeta, IServiceCodeFormMeta, IEncodedTrackFormMeta, IEmbossedDataFormMeta {
    
};

const magneticTapeApplicationFormMeta: IMagneticTapeApplicationFormMeta = { ...cardNetworkType_PinTrialLimitFormMeta, ...internetMailOrderFormMeta, ...serviceCodeFormMeta, ...encodedTrackFormMeta, ...embossedDataFormMeta};

export default magneticTapeApplicationFormMeta;

export type TMagneticTapeApplication = {
    cardNetworkType_PinTrialLimitFormMeta: ICardNetTyp_PinTrialLimFormMeta;
    internetMailOrderFormMeta: I_InternetMailOrderFormMeta;
    serviceCodeFormMeta: IServiceCodeFormMeta;
    encodedTrackFormMeta: IEncodedTrackFormMeta;
    embossedDataFormMeta: IEmbossedDataFormMeta;
}

export const mtaFormMetaObj: TMagneticTapeApplication = {cardNetworkType_PinTrialLimitFormMeta, internetMailOrderFormMeta, serviceCodeFormMeta, encodedTrackFormMeta, embossedDataFormMeta}